import React from 'react';
import { useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
import messageIcon from '@iconify-icons/lucide/message-circle';

// Rutas donde el FAB NO se muestra (auth, error, examen en curso).
const HIDE_ON = [
  '/login',
  '/course-exam/', // durante el examen la barra inferior fija ya ocupa esa esquina
];

/**
 * Botón flotante de chat/soporte (Academy Rediseño.dc.html · líneas 138-140).
 *
 * Fixed bottom-right 56px con icono message-circle de lucide. La URL destino
 * se toma de `process.env.REACT_APP_CONTACT_URL` (típicamente `https://wa.me/…`
 * o `mailto:soporte@…`). Con fallback `/contact-us` — si nadie lo configura,
 * al menos lleva a la página de contacto del propio sitio.
 *
 * Se oculta en login/registro y en el propio examen (donde ya hay una barra
 * inferior fija que ocuparía el mismo espacio).
 */
export default function ChatFab() {
  const { pathname } = useLocation();
  if (HIDE_ON.some((prefix) => pathname === prefix || pathname.startsWith(prefix))) {
    return null;
  }

  const href = process.env.REACT_APP_CONTACT_URL || '/contact-us';
  const isExternal = /^(https?:|mailto:|tel:)/.test(href);

  return (
    <a
      href={href}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      aria-label="Abrir chat de soporte"
      style={{
        position: 'fixed',
        right: 18,
        bottom: 'calc(18px + env(safe-area-inset-bottom))',
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: 'var(--color-accent)',
        border: 0,
        boxShadow: '0 10px 24px rgba(16, 28, 54, 0.32)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 55,
        color: 'var(--color-ink)',
        textDecoration: 'none',
      }}
    >
      <Icon icon={messageIcon} width={25} height={25} aria-hidden="true" />
    </a>
  );
}
